import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import ReactCSSTransitionReplace from 'react-css-transition-replace';
import queryString from 'query-string';

import Immutable from 'seamless-immutable';
import { LoadingIndicator, ProgressBar, Button } from '../../components';
import { ThemeColors } from '../../theme';
import { ChecklistItemGroup } from '../../main/checklist';

import restart from '../../../images/restart.png';
import env from '../../../run-config';

import pdf from '../../../images/pdf.png';

import ENV from '../../../run-config';
import { blue300 } from 'material-ui/styles/colors';

const INITIAL_STATE = {
  checklistItemIndex: 0,
  score: 0,
  selectedAnswers: Immutable({}),
};

class ChecklistItemChecking extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;
    this.answerSelectionChanged = this.answerSelectionChanged.bind(this);
    this.restart = this.restart.bind(this);
    this.exportView = queryString.parse(this.props.location.search).exportView;
    // this.resultId = queryString.parse(this.props.location.search).resultId;
  }

  componentWillMount() {
    const checklistItemId = queryString.parse(
      this.props.location.search
    ).checklistItemId;
    if (checklistItemId) this.props.loadChecklistItem(checklistItemId);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.runStartedAt &&
      nextProps.runStartedAt !== this.props.runStartedAt
    ) {
      this.setState(
        Object.assign({}, INITIAL_STATE, {
          score: nextProps.checklistItems
            ? 1 / nextProps.checklistItems.length
            : 0,
          currentIndex: 1,
          totalChecklistItems: nextProps.checklistItems
            ? nextProps.checklistItems.length
            : 0,
        })
      );
    }

    if (!this.state.score && nextProps.checklistItems) {
      this.setState({
        score: 1 / nextProps.checklistItems.length,
        currentIndex: 1,
        totalChecklistItems: nextProps.checklistItems.length,
      });
    }
  }

  onClickShare = (checklistItem) => {
    const url = `${env.apiHost}/checklists/${this.props.checklist.id}?checklistItemId=${checklistItem.id}`;
    this.props.onExportContent(url);
  };

  restart() {
    this.props.removeChecklistRun(this.props.checklistRun.id);
    this.props.startNewChecklistRun(this.props.checklist);
    this.setState({
      score: 0,
      checklistItemIndex: 0,
    });
  }

  answerSelectionChanged(checklistItem, selectedAnswers) {
    let selectedAnswersForChecklistItem = this.state.selectedAnswers;

    selectedAnswersForChecklistItem = selectedAnswersForChecklistItem.set(
      checklistItem.id,
      selectedAnswers
    );

    this.setState({
      selectedAnswers: selectedAnswersForChecklistItem,
    });
  }

  renderButtons(checklistItem) {
    const { classes } = this.props;
    return (
      <div className="col-md-12 col-lg-12">
        <Button
          onClick={() => this.props.submitChecklist(checklistItem)}
          label="Speichern"
          variant="contained"
          className={`pm-course-button ${classes.buttonStyle}`}
          style={{ background: ThemeColors.positiveColor, marginRight: '10px' }}
          backgroundColor={ThemeColors.positiveColor}
          labelStyle={{
            color: ThemeColors.positiveColorTextColor,
            fontSize: 12,
          }}
        />
        <Button
          onClick={() => this.props.finishChecklistRun(this.props.checklistRun)}
          label="Checkliste abschließen"
          variant="contained"
          className={`pm-course-button ${classes.buttonStyle}`}
          style={{ background: blue300 }}
          backgroundColor={ThemeColors.positiveColor}
          labelStyle={{
            color: ThemeColors.positiveColorTextColor,
            fontSize: 12,
          }}
        />
      </div>
    );
  }

  renderContent() {
    return (
      <div>
        <div
          className="col-sm-12 col-md-8 col-lg-8"
          style={{ marginBottom: '40px' }}
        >
          <ReactCSSTransitionReplace transitionName="carousel-swap">
            <div>
              {this.props.checklistItemGroups.map((checklistItemGroup) => (
                <ChecklistItemGroup
                  checklistItemGroup={checklistItemGroup}
                  key={checklistItemGroup.id}
                />
              ))}
            </div>
          </ReactCSSTransitionReplace>
          {this.renderButtons()}
          <div className="doNotPrint"></div>
        </div>

        <div className="col-sm-12 col-md-4 col-lg-4">
          {this.props.sideBarContent}
        </div>

        <div
          className="col-md-12 col-lg-10 doNotPrint"
          style={{ marginBottom: 50, marginTop: 10 }}
        ></div>
      </div>
    );
  }

  render() {
    if (this.props.isLoading) {
      return <LoadingIndicator show centered />;
    }

    if (!this.props.checklist) {
      return null;
    }

    return (
      <div>
        <div className="col-md-12 col-lg-12">
          <div style={{ paddingLeft: '5px', position: 'relative' }}>
            <h1 style={{ color: ThemeColors.accent2Color }}>
              {this.props.checklist.name || this.props.checklist.checklistName}
            </h1>
            <span style={{ right: 0, position: 'absolute', top: 20 }}>
              {this.props.score}/{this.props.checklistItems.length}
            </span>
          </div>
          <div style={{ marginBottom: 20 }}>
            <ProgressBar
              progress={this.props.score / this.props.checklistItems.length}
            />
          </div>
        </div>
        {this.renderContent()}
      </div>
    );
  }
}

const styles = () => ({
  buttonStyle: {
    fontSize: '14px',
    marginTop: '20px',
    height: 60,
  },
  sideButtonStyle: {
    textAlign: 'left',
    display: 'block',
    minWidth: 260,
    marginBottom: 5,
    height: 50,
  },
  iconStyle: {
    width: 45,
    height: 45,
  },
});

ChecklistItemChecking.propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.object,
  runStartedAt: PropTypes.object,
  checklist: PropTypes.object,
  card: PropTypes.object,
  checklistRun: PropTypes.object,
  config: PropTypes.object,
  completed: PropTypes.bool,
  isLoading: PropTypes.bool,
  exportView: PropTypes.bool,
  hideLinkedCardButton: PropTypes.bool,
  hideSideBarButtons: PropTypes.bool,
  checklistItems: PropTypes.array,
  onRestart: PropTypes.func,
  onSubmitAnswer: PropTypes.func,
  onSubmitChecklist: PropTypes.func,
  onLoadCard: PropTypes.func,
  onCloseLinkedCard: PropTypes.func,
  onOpenResults: PropTypes.func,
  onOpenChecklists: PropTypes.func,
  sideBarContent: PropTypes.any,
};

ChecklistItemChecking.defaultProps = {
  location: null,
  runStartedAt: null,
  checklist: null,
  card: null,
  checklistRun: null,
  config: null,
  completed: false,
  isLoading: false,
  exportView: false,
  hideLinkedCardButton: false,
  hideSideBarButtons: false,
  checklistItems: [],
  onRestart: () => {},
  onSubmitAnswer: () => {},
  onSubmitChecklist: () => {},
  onLoadCard: () => {},
  onCloseLinkedCard: () => {},
  onOpenResults: () => {},
  onOpenChecklists: () => {},
  sideBarContent: () => {},
};

export default withStyles(styles)(ChecklistItemChecking);



// WEBPACK FOOTER //
// ./src/app/components/checklist_checking/checklistItem-checking.js